import { BreakpointObserver } from "@angular/cdk/layout";
import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { AuthUser } from "@app/auth/model/auth-user";
import { AuthSelectors, AuthState } from "@app/auth/store";
import { CustomerPortalService } from "@app/customer-portal/services/customer-portal.service";
import { MatIconLoaderService } from "@app/shared/services/mat-icon-loader.service";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, map, tap } from "rxjs/operators";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
    public user$: Observable<AuthUser>;
    public isMobile$: Observable<boolean>;
    public isFirstSignup$: Observable<boolean>;

    public get isEmbedded() {
        return !!(window as any).mchObserver;
    }

    constructor(
        private store: Store<AuthState>,
        private readonly breakpointObserver$: BreakpointObserver,
        private readonly titleService: Title,
        private readonly customerPortalService: CustomerPortalService,
        readonly matIconLoader: MatIconLoaderService,
        private readonly router: Router
    ) {
        matIconLoader.importIcons([["exclamation", "exclamation"]]);
    }

    ngOnInit() {
        this.user$ = this.store.pipe(select(AuthSelectors.selectGetUser));
        this.isMobile$ = this.breakpointObserver$.observe(["(max-width: 959px)"]).pipe(map(mobileQuery => mobileQuery.matches));
        this.isFirstSignup$ = this.customerPortalService.isFirstSignup$.pipe(tap(isFirstSignup => isFirstSignup));
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => {
                    let route: ActivatedRoute = this.router.routerState.root;
                    let routeTitle = "";
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    if (route.snapshot.data["title"]) {
                        routeTitle = route.snapshot.data["title"];
                    }
                    return routeTitle;
                })
            )
            .subscribe((title: string) => {
                if (title) {
                    this.titleService.setTitle(`FusionPro - ${title}`);
                }
            });
    }
}
